import EventService from "@/services/Event";

export default [
    {
        path: '/live',
        name: 'live-event',
        component: () => import(/* webpackChunkName: "homepage" */ '../views/HomePage.vue'),
        beforeEnter: (to, from, next) => {
            EventService.getLiveEvent(to.query || null).then(response => {
                window.location.href = response.data.gallery_url
            }).catch(error => {
                next('/')
            })
        }
    },
]

